import { AxiosResponse, CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'
import { MySelfInterface } from '../../../interface/my-self.interface'

export const getMySelfService = (
  cancelToken?: CancelToken,
): Promise<AxiosResponse<MySelfInterface>> =>
  apiInstance.get(ApiPathConfig.MY_SELF, { cancelToken })
